import styled from "styled-components";
import colors from "css/colors";

export const ShipmentTagDescription = styled.div`
  display: inline-flex;
  padding: 5px;
  color: ${colors.GREY};
`;
